import type { ITelemetryCustom } from "@/lib/telemetry";
import { urlFormat } from "@Components/Modules/Helpers/UrlHelper";
import { Telemetry } from "@Routes/TelemetryLinks";

export const requestTrack = (trackUrl?: string, method?: "GET" | "POST"): void => {
    if (trackUrl) {
        fetch(trackUrl, { method: method || "GET" });
    }
};

export const genericTelemetry = (
    action: string,
    eventType: string,
    actionType: TelemetryActionType,
    params?: object,
) =>
    urlFormat(
        Telemetry,
        {
            action,
            eventType,
            actionType,
            ...params,
        },
        true,
    );

export type TelemetryProps = PropsTelemetryCustom & {
    telemetryUrl?: string;
    ajaxTrackAction?: string;
    trackingUrl?: string;
};

export type PropsTelemetryCustom = {
    telemetryCustom?: ITelemetryCustom;
};

export type TelemetryActionType = "Undefined" | "View" | "Click" | "Swipe" | "Display";
export type TelemetryClickFromType =
    | "Undefined"
    | "Login"
    | "ForYou"
    | "SearchResult"
    | "DiscDetails"
    | "FlyerDetails"
    | "FlyerViewer"
    | "FlyerViewerSearch"
    | "FlyersWorld"
    | "Favorites"
    | "Brands"
    | "BrandDetails"
    | "SponsoredBrand"
    | "Malls"
    | "MallOffers"
    | "MallBrands"
    | "MallDetails"
    | "MallsAll"
    | "PredefMallFilter"
    | "SettingsProfile"
    | "SettingsForU"
    | "BrandsAll"
    | "SpecialEvent"
    | "BrandsNewOccasions"
    | "SavedMallOffers"
    | "SavedDiscounts"
    | "Map"
    | "Search"
    | "About"
    | "LtLandingPage"
    | "Ecommerce"
    | "GenericLandingPage"
    | "Homepage"
    | string;

export const TelemetryEntity = {
    Discount: "Discount",
    Flyer: "Flyer",
    Brand: "Brand",
    FlyerDetails: "FlyerDetails",
    BrandDetails: "BrandDetails",
    Category: "Category",
    ShoppingMall: "ShoppingMall",
    SpecialMoment: "SpecialMoment",
    Search: "search",
    VideoBanner: "VideoBanner",
    LoyaltyProgram: "LoyaltyProgram",
    Cashback: "cshbck",
    Common: "common",
    NavigationBar: "btmbar",
    Settings: "usprfl",
    Homepage: "homepg",
    UserCommunication: "UserCommunication",
    Login: "login",
    Register: "rgstr",
    About: "About",
    Comparison: "prcomp",
};

export const FlyerEventType = {
    flyerPagesClick: "FlyerPagesClick",
    pageBrowse: "pageBrowse",
    pageBanner: "pageBanner",
    flyerClick: "flyerClick",
};

export const CommonEventType = {
    exit: "exit",
    next: "next",
    appBtn: "appBtnClick",
    back: "back",
    save: "save",
    email: "Email",
    login: "login",
    register: "register",
    registerIn: "registerIn",
};

export const HomeEventType = {
    CashbackIntroArrowClick: "cshbckIntroArrowClick",
    CashbackIntroView: "cshbckIntroView",
    CashbackIntro: "cshbckIntroBtnClick",
    CashbackBrandsSwipe: "cshbckBrndsSwipe",
    CashbackBrandsView: "cshbckBrndsView",
    CashbackBrandsMore: "cshbckBrndsMore",
    MoreDiscountsButton: "discountBtnMore",
    DiscountsSwipe: "discountSwipe",
    DiscountsView: "discountsView",
    ShoppingListDisplay: "shoppingListDisplay",
    AppIntroduceView: "appIntroduceView",
    MapsDisplay: "mapsDisplay",
    LoyaltyDisplay: "loyaltyDisplay",
    GiftCardDisplay: "giftCardDisplay",
    GiftCardMoreClick: "ggcMoreClick",
    TopBarBtnClick: "topbarBtnClick",
    TopBarClose: "topbarClose",
    TopBarView: "topbarView",
    TopSliderView: "topSliderView",
    TopSliderButtonClick: "topSliderBtnClick",
    FooterSocialClick: "footerSocialClick",
    FlyersButtonMore: "flyersBtnMore",
    FlyersArrowClick: "flyersArrowClick",
    FlyersView: "flyersView",
    FlyerBrandsSwipe: "flyerBrandsSwipe",
    FlyerBrandsView: "flyerBrandsView",
    FlyerBrandMore: "flyerBrandMore",
    ShoppingMallsSwipe: "shpMallSwipe",
    ShoppingMallsView: "shpMallView",
    LatestContentMore: "latestContentMore",
    LatestArtClick: "latestArtClick",
    SeasonArtClick: "seasonArtClick",
    SeasonContentSwipe: "seasonContentSwipe",
    LatestContentView: "latestContentView",
    PopCouponClick: "popCouponClick",
    SmartTileSwipe: "smartTitleSwipe",
    SmartTileClick: "smartTitleClick",
};

export const MgmEventType = {
    Dashboard: "mgmDshbrd",
    DashboardGuest: "mgmDshbrdGuest",
    OffPage: "mgmDshbrdOff",
    DashboardSummary: "mgmTrxSummary",
    DashboardShopping: "mgmStartShopping",
    RedeemCodePage: "goodieRedeemCode",
    MgmTrxModal: "mgmBonusList",
    MgmTrxModalRejectedTab: "mgmBonusRejectedTab",
    MgmTrxModalApprovedTab: "mgmBonusApprovedTab",
    MgmTrxModalPendingTab: "mgmBonusPendingTab",
    PhoneVerificationPage: "mgmPhoneNumberInput",
    SmsPage: "mgmSmsCodeInput",
    SmsCodeInput: "mgmSmsCodeInput",
    SmsPageNumberCorrect: "PhoneNumberCorrect",
    SmsCodeResend: "SmsCodeResend",
    receiverSuccess: "mgmReceiverSuccess",
    mainPage: "mgmDshbrdLogged",
    mainPageCtaVerifyPhone: "mgmDshbrdLoggedCTAVerify",
    mainPageCtaMakeTrx: "mgmDshbrdLoggedCTAMakeTrx",
    mainDashboardCodeShare: "mgmDshbrdShareLink",
    mainDashboardCodeEdit: "mgmDshbrdEditCode",
    dashboardReferralCodeEdit: "mgmReferralCodeEdit",
    loginAndRegisterParam: "mgmReceiver",
    registerConsents: "SocialTermsConditions",
    socialTermsClick: "TermsConditionsCheckbox",
};

export const BannerEventType = {
    Banner: "banner",
    BannerSlide: "bannerSlide",
    BannerClick: "bannerClick",
    BannerChange: "bannerChange",
};

export const BrandEventType = {
    BrandClick: "brandClick",
    BrandHorizontalSwipe: "brandHorizontalSwipe",
};

export const SmartTileEventType = {
    Undefined: "Undefined",
    SmartTileView: "SmarttileView",
    SmartTileClick: "SmarttileClick",
    MallSmartTileClick: "MallsmarttileClic",
};

export const CashbackEventType = {
    MediaArticle: "mediaArticle",
    TrxMakeClaim: "trxMakeClaim",
    TrxPendingTab: "trxPendingTab",
    TrxApprovedTab: "trxApprovedTab",
    TrxWithdrawalTab: "trxWithdrawalTab",
    TrxRejectedTab: "trxRejectedTab",
    PicBrand: "picBrand",
    BottomBannerRegister: "bottomBannerRegister",
    WithdrawalDetailsOpen: "wthdrDetailsOpen",
    TrxDetailsOpen: "trxDetailsOpen",
    OfferSummaryDets: "offerSummaryDets",
    OfferSummary: "offerSummary",
    GoToStore: "GoToStore",
    OutboundInfo: "outboundInfo",
    OutboundInfoGoToStore: "outboundInfoGoToStore",
};
